export default __webpack_public_path__ + "media/images/icons/map-pin-4277cb9b400bc7ab009e7c180e29f55d.svg";